module.exports = __webpack_public_path__ + "img/스페셜.80529847.png";